/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getQuickRequestComments } from "api/services/quickRequest";
import { quickRequestQueryKeys } from "./quickRequestQueryKeys";

export const useGetQuickRequestComments = (qrNumber: string, options: UseQueryOptions) =>
  useQuery({
    queryKey: quickRequestQueryKeys.quickRequestCommentsListing(qrNumber),
    queryFn: () => getQuickRequestComments(qrNumber).then((res) => res.data),
    ...options,
  });
